const translations = {
  fr: {
    campaigns: {
      campaignsPageTitle: 'Campagnes',
      sortedBy: 'Ordonné par',
      startDate: 'Date de début',
      nbOpp: 'Nb occ.',
      campaignName: 'Nom de la campagne',
      unavailableCampaigns: 'Campagnes indisponibles',
      campaignStart: 'Début campagne',
      manage: 'Gérer',
      manageSpots: 'Gérer les spots',
      linkCampaign: 'Liaison de campagnes externes',
      linkCampaignLabel: 'Campagne externe',
      linking: 'Liaison',
      linkCampaignMessage: 'En liant une campagne externe à cette campagne, les spots seront automatiquement transférés et synchronisés à cette campagne.',
      linkCampaignsMessage: 'En liant une ou plusieurs campagnes externes à cette campagne, les spots seront automatiquement transférés et synchronisés.',
      cannotLinkRunningCampaignMessage: 'Seulement le directeur des ventes peut lier une campagne commencée',
      selectACampaign: 'Sélectionnez une campagne',
      selectACampaignOrTypeSomething: '$t(selectACampaign) ou entrez du texte pour rechercher',
      noMoreExternalCampaignsToSelect: 'Il n\'y a plus de campagne externe non liée',
      campaignLinkedSuccessfully: 'La campagne a été liée avec succès',
      campaignLinkFailed: 'La liaison de la campagne a échouée',
      seeCampaignsButton: 'Voir les campagnes',
      editCampaignMessage: 'Éditer le message de la campagne',
      completeCampaignError: 'Il y a eu une erreur lors de la complétion de la campagne',
      spotsSold: 'Spot vendu',
      spotsSold_plural: 'Spots vendus',
      noPermissionToFetchCampaignsListing: 'Vous n\'avez pas accès à la liste de campagnes',
      audioFileTooLarge: 'Ce fichier est trop volumineux (maximum de {{maxFileSizeInMegabytes}} MO)',
      noCampaignFound: 'Aucune campagne trouvée',
      noCampaignFoundForSearch: require('./markdown/fr/noCampaignFoundForSearch.md'),
      errorWhileFetchingCampaigns: require('./markdown/fr/errorWhileFetchingCampaigns.md'),
      couldNotDeleteCampaign: 'Une erreur est survenue lors de la suppression de la comagne',
      campaignDeletedSuccessfully: 'La campagne a été supprimée avec succès',
      finalization: {
        message: 'Vous êtes sur le point de finaliser la campagne "{{campaignName}}".',
        notifyAdvertiserMessage: 'Le client, {{customerName}}, recevra un courriel via la plateforme Follo.',
        campaignWithoutSpotMessage: 'Comme la campagne n\'a pas de spot, celle-ci sera supprimée.',
        notifyClientCheckboxText: 'Notifier le client par courriel',
      },
      printCampaign: '$t(print) le rapport',
      status: {
        RUNNING: 'En cours',
        NOT_LINKED: 'Non appariée',
        NOT_STARTED: 'Débute dans {{fromNow}}',
        TO_COMPLETE: 'À finaliser',
        COMPLETED: 'Terminée',
      },
      actions: {
        LINK: 'Apparier',
        COMPLETE: 'Finaliser',
      },
      today: 'Aujourd\'hui',
      yesterday: 'Hier',
      list: {
        status: 'Statut',
        start: 'Début',
        campaignName: 'Nom de la campagne',
        callSign: 'Station',
        linking: 'Appariement',
        costs: 'Coût total',
        customer: 'Client',
        actions: 'Actions',
      },
      createCampaign: 'Créer campagne',
      pagination: {
        goToPage: 'Aller à la page',
        currentPage: '{{currentPage}} sur {{numberOfPages}}',
      },
      createDemoCampaign: 'Créer une campagne-démo',
      couldNotCreateDemoCampaign: 'Une erreur est survenue lors de la création de la campagne-démo',
      demoCampaignCreatedSuccessfully: 'Campagne-démo créée avec succès',
      enterCampaignTitle: 'Entrez le titre de la campagne',
      demoCampaignTitle: 'Titre de la campagne-démo',
      demoCampaignDates: 'Dates de la campagne-démo',
      filters: {
        noFilter: 'Aucun filtre',
        toLink: 'À apparier',
        toComplete: 'À finaliser',
      },
      broadcastMonth: 'Mois de diffusion',
      numberOfSpots: 'Nombre d\'opportunités',
      campaignWillBeAvailableInFollo: 'Une fois la création complétée, {{customerName}} aura accès à la campagne dans Follo.',
      activateCampaignInFollo: "Cette activation est permanente. Vous pourrez toutefois donner l'accès à Follo ultérieurement.",
      activateCampaignInFolloButton: 'Activer dans Follo',
      activateCampaignInFolloAction: 'Activer la campagne dans Follo',
      activateCampaignInFolloForCustomerWithoutFolloAccess: require('./markdown/fr/custumerName.md'),
    },
  },
  en: {
    campaigns: {
      campaignsPageTitle: 'Campaigns',
      sortedBy: 'Sorted by',
      startDate: 'Start date',
      unavailableCampaigns: 'Campaigns unavailable',
      nbOpp: 'Nb opp.',
      campaignName: 'Campaign Name',
      campaignStart: 'Campaign start',
      manage: 'Manage',
      manageSpots: 'Manage spots',
      linkCampaign: 'External campaigns linking',
      linking: 'Linking',
      linkCampaignLabel: 'External Campaign',
      linkCampaignMessage: 'When linking an external campaign to this campaign, every spot will be automatically transferred and synchronized.',
      linkCampaignsMessage: 'When linking one or multiple external campaigns to this campaign, every spot will be automatically transferred and synchronized.',
      cannotLinkRunningCampaignMessage: 'Only the sales director can link a running campaign',
      selectACampaign: 'Select a campaign',
      selectACampaignOrTypeSomething: '$t(selectACampaign) or type something to search',
      noMoreExternalCampaignsToSelect: 'There\'s no more unlinked external campaign',
      campaignLinkedSuccessfully: 'Successfully linked the campaign',
      campaignLinkFailed: 'Failed to link the campaign',
      seeCampaignsButton: 'See campaigns',
      completeCampaignError: 'There was an error while completing the campaign',
      editCampaignMessage: 'Edit campaign message',
      spotsSold: 'Spot sold',
      spotsSold_plural: 'Spots sold',
      noPermissionToFetchCampaignsListing: 'Cannot access campaigns listing',
      audioFileTooLarge: 'This file is too large (max {{maxFileSizeInMegabytes}} MB)',
      noCampaignFound: 'No campaign found',
      noCampaignFoundForSearch: require('./markdown/en/noCampaignFoundForSearch.md'),
      errorWhileFetchingCampaigns: require('./markdown/en/errorWhileFetchingCampaigns.md'),
      couldNotDeleteCampaign: 'An error occured while deleting the campaign',
      campaignDeletedSuccessfully: 'Campaign deleted successfully',
      finalization: {
        message: 'You\'re about to complete campaign "{{campaignName}}"',
        notifyAdvertiserMessage: 'The customer, {{customerName}}, will receive an email from our Follo platform.',
        campaignWithoutSpotMessage: 'Since the campaign has no spots, it will be deleted.',
        notifyClientCheckboxText: 'Notify client with an email',
      },
      printCampaign: '$t(print) Report',
      status: {
        RUNNING: 'Running',
        NOT_LINKED: 'Not Paired',
        NOT_STARTED: 'Starts in {{fromNow}}',
        TO_COMPLETE: 'To Complete',
        COMPLETED: 'Completed',
      },
      actions: {
        LINK: 'Pair',
        COMPLETE: 'Complete',
      },
      today: 'Today',
      yesterday: 'Yesterday',
      list: {
        status: 'Status',
        start: 'Start',
        campaignName: 'Campaign Name',
        callSign: 'Station',
        linking: 'Pairing',
        costs: 'Costs',
        customer: 'Customer',
        actions: 'Actions',
      },
      createCampaign: 'Create Campaign',
      pagination: {
        goToPage: 'Go to page',
        currentPage: '{{currentPage}} of {{numberOfPages}}',
      },
      createDemoCampaign: 'Create a Demo Campaign',
      couldNotCreateDemoCampaign: 'Could not create demo campaign',
      demoCampaignCreatedSuccessfully: 'Demo campaign created successfully',
      enterCampaignTitle: 'Enter campaign title',
      demoCampaignTitle: 'Demo campaign title',
      demoCampaignDates: 'Demo campaign dates',
      filters: {
        noFilter: 'No Filter',
        toLink: 'To Link',
        toComplete: 'To Complete',
      },
      broadcastMonth: 'Broadcast Month',
      numberOfSpots: 'Number of Spots',
      campaignWillBeAvailableInFollo: 'Once the campaign is created, {{customerName}} will be able to access it in Follo.',
      activateCampaignInFollo: 'This action is permanent, you will be able to give access to Follo later',
      activateCampaignInFolloButton: 'Activate in Follo',
      activateCampaignInFolloAction: 'Activate campaign in Follo',
      activateCampaignInFolloForCustomerWithoutFolloAccess: require('./markdown/en/custumerName.md'),
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/i18n/campaigns.js